import langEN from './en-US.json'
import langNL from './nl-NL.json'

const messages = {
  'en-US': {
    AccountInvitations: langEN.AccountInvitations,
    Shared: langEN.Shared,
  },
  'nl-NL': {
    AccountInvitations: langNL.AccountInvitations,
    Shared: langNL.Shared,
  },
}

messages['en-US'][process.env.FRONTEND_TYPE] = langEN[process.env.FRONTEND_TYPE]
messages['nl-NL'][process.env.FRONTEND_TYPE] = langNL[process.env.FRONTEND_TYPE]

export default messages
